/* eslint-disable no-redeclare */
import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { AreYouCurrentlyEnrolledInMedicareOrBlank } from '../survey-answers';

export const UpdateProspectEnrolledPartAPartBParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  areYouCurrentlyEnrolledInMedicare: AreYouCurrentlyEnrolledInMedicareOrBlank,
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
});

export type UpdateProspectEnrolledPartAPartBParameters = z.infer<
  typeof UpdateProspectEnrolledPartAPartBParameters
>;
